/** Before using this, check whether there's 'REACT_APP_ENV' on Bitbucket => Repository Settings => Deployments Variables */
const isNotProduction = () => process.env.REACT_APP_ENV !== 'production';

const isNotStage = () => process.env.REACT_APP_ENV !== 'stage';

const isLocal = () => process.env.REACT_APP_ENV === 'local';

export { isNotProduction, isNotStage, isLocal };
